import { render } from "./SharedAnnotations.vue?vue&type=template&id=091bd4e7&scoped=true"
import script from "./SharedAnnotations.vue?vue&type=script&lang=js"
export * from "./SharedAnnotations.vue?vue&type=script&lang=js"

import "./SharedAnnotations.vue?vue&type=style&index=0&id=091bd4e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091bd4e7"]])

export default __exports__